import React from "react";
import Button from "@civicplus/preamble-ui/lib/Button";
import NotificationsIcon from "@material-ui/icons/Notifications";
import ButtonGroup from "@civicplus/preamble-ui/lib/ButtonGroup";
import { makeStyles } from "@civicplus/preamble-ui/lib/Utilities/ThemeHelper";
import { makeFullUrl } from "../../utils";
const useStyles = makeStyles(theme => ({
  btnGroup: {
    display: "inline-block",
    margin: theme.spacing(2),
  },
}));

const ManageSubscription: React.FC = () => {
  const classes = useStyles();
  return (
    <ButtonGroup layout="right" className={classes.btnGroup}>
      <Button
        id="login"
        data-testid="subs-btn"
        href={makeFullUrl("/subscriptions")}
        openInNewWindow={true}
        color="default"
        type="default"
        title="Manage Subscriptions"
        size="small"
        startIcon={<NotificationsIcon color="secondary" fontSize="small" />}
      >
        Subscriptions
      </Button>
    </ButtonGroup>
  );
};
export default ManageSubscription;
